import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Loader from 'components/Loader';
import { completeLoginAfterAuth, getUserManager } from 'domains/auth/Auth.util';
import { isLocalEnvironment } from 'env';

const LoginRedirect = (): JSX.Element => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const userManager = getUserManager();

    if (isLocalEnvironment()) {
      userManager
        .signinRedirectCallback()
        .then(() => completeLoginAfterAuth(dispatch, history))
        .catch(() => {
          history.push('/');
        });
      return;
    }

    userManager.signinPopupCallback();
  }, [dispatch, history]);

  return <Loader />;
};

export default LoginRedirect;
